// 初回ヒアリング: 動的質問定義 (要件 §7-2)
// 将来は DB 化する余地を残すため version を付与
import type { HearingQuestionDTO } from "./dto";

export const HEARING_QUESTIONS_VERSION = 3;

export const HEARING_QUESTIONS: HearingQuestionDTO[] = [
  { code: "full_name",         label: "氏名",                 type: "text",         required: true,  sortOrder: 10 },
  { code: "kana",              label: "フリガナ",             type: "text",         required: true,  sortOrder: 15 },
  { code: "display_name",      label: "表示名",               type: "text",         required: true,  sortOrder: 20 },
  { code: "company_name",      label: "会社名 / 屋号",         type: "text",         required: false, sortOrder: 30 },
  { code: "industry",          label: "業種",                 type: "text",         required: false, sortOrder: 40 },
  { code: "business_stage",    label: "事業ステージ",          type: "select",       required: false, sortOrder: 50,
    options: [
      { value: "idea",     label: "構想中" },
      { value: "early",    label: "立ち上げ期" },
      { value: "growth",   label: "成長期" },
      { value: "scale",    label: "拡大期" },
      { value: "mature",   label: "成熟期" },
    ],
  },
  { code: "annual_revenue_band", label: "年商帯",             type: "select",       required: false, sortOrder: 60,
    options: [
      { value: "lt_10m",       label: "1000万未満" },
      { value: "10m_50m",      label: "1000万〜5000万" },
      { value: "50m_100m",     label: "5000万〜1億" },
      { value: "100m_500m",    label: "1億〜5億" },
      { value: "500m_1b",      label: "5億〜10億" },
      { value: "1b_3b",        label: "10億〜30億" },
      { value: "3b_10b",       label: "30億〜100億" },
      { value: "gte_10b",      label: "100億以上" },
    ],
  },
  { code: "employee_band",     label: "従業員数",             type: "select",       required: false, sortOrder: 70,
    options: [
      { value: "1",        label: "1名" },
      { value: "2_5",      label: "2〜5名" },
      { value: "6_20",     label: "6〜20名" },
      { value: "21_50",    label: "21〜50名" },
      { value: "51_100",   label: "51〜100名" },
      { value: "101_200",  label: "101〜200名" },
      { value: "201_500",  label: "201〜500名" },
      { value: "gte_500",  label: "500名以上" },
    ],
  },
  { code: "challenges",        label: "主な課題（複数可）",    type: "multi_select", required: false, sortOrder: 80,
    options: [
      { value: "sales",       label: "売上拡大" },
      { value: "marketing",   label: "集客・マーケ" },
      { value: "hiring",      label: "採用" },
      { value: "financing",   label: "資金調達" },
      { value: "operations",  label: "業務効率化" },
      { value: "succession",  label: "事業承継" },
    ],
  },
  { code: "strengths",         label: "得意領域",             type: "textarea",     required: false, sortOrder: 90 },
  { code: "support_needs",     label: "求める支援",           type: "textarea",     required: false, sortOrder: 100 },
  { code: "applicant_history", label: "志願者経験 / 志願予定", type: "select",       required: false, sortOrder: 110,
    options: [
      { value: "none",      label: "なし" },
      { value: "planned",   label: "志願予定" },
      { value: "applied",   label: "志願経験あり" },
    ],
  },
  { code: "offer_areas",       label: "紹介可能分野",         type: "textarea",     required: false, sortOrder: 120 },
  { code: "self_intro",        label: "自己紹介",             type: "textarea",     required: false, sortOrder: 130 },
  { code: "is_public",         label: "プロフィール公開可否",  type: "boolean",      required: false, sortOrder: 140 },
];
